import type { Node } from '../../../core/models/scene';

/** Visual defaults only: never inherit labels, bindings, locks or process facts. */
export function flowchartStyleInheritance(node?: Node): Record<string, unknown> {
  if (!node) return {};
  const result: Record<string, unknown> = {};
  const values = node as unknown as Record<string, unknown>;
  const attrs = node.attrs ?? {};
  for (const field of ['fillColor', 'strokeColor', 'fontSize', 'fontFamily', 'textColor']) {
    const value = field === 'fillColor' || field === 'strokeColor'
      ? values[field] ?? attrs[field]
      : attrs[field] ?? values[field];
    if (value !== undefined) result[field] = value;
  }
  for (const field of ['strokeWidth', 'dash', 'dashEnabled', 'fontWeight', 'fontStyle', 'textDecoration', 'textAlign', 'verticalAlign']) {
    const value = attrs[field] ?? values[field];
    if (value !== undefined) result[field] = structuredClone(value);
  }
  return result;
}
